export default {
  text_1_1: 'チュートリアル',

  text_2_1: 'バックアップ手順',
  text_2_2: 'インポート手順',
  text_2_3: '上級チュートリアル（支払い機能）',

  text_3_1: 'ウォレット作成',
  text_3_1_1: '「Create Wallet」を選択後、バックアップ手順へ進みます。',

  text_3_2: 'バックアップ',
  text_3_2_1:
    'バックアップページで「KeyPal Card バックアップ」を選択します。手順は4段階：（1）KeyPal Card の PIN を設定；（2）復元フレーズをカードにバックアップ；（3）バックアップの正確性を検証；（4）利用開始。',
  text_3_2_2:
    '「バックアップ開始」をタップします。誤入力防止のため PIN は2回入力します。PIN はバックアップの安全性とカードへのアクセス制御に使用します。注意：PIN の管理は自己責任です。必ず覚えてください！',
  text_3_2_3:
    'PIN 設定後、案内に従い KeyPal Card をスマホ背面カメラ（NFC 感知部）に当てます。iOS では安全な接続の確立に数秒かかる場合があり、短い遅延は正常です。',
  text_3_2_4:
    '感知が完了しデータが正確であれば、復元フレーズは暗号化されカードに書き込まれます。完了後、画面に完了メッセージが表示されます。',
  text_3_2_5:
    'バックアップ完了後は最終ステップの「バックアップ検証」に進みます。実施を強く推奨します！',

  text_3_3: '検証',
  text_3_3_1:
    '案内に従い、事前に設定したカードの PIN を入力します。入力後、カードを背面カメラ付近にかざして NFC 感知を行います。',
  text_3_3_2:
    '検証に成功するとメッセージが表示されます。ニーモニック漏えい防止のため一部は伏字表示です。指示に従い語句を照合してください。',
  text_3_3_3:
    '検証完了後は「次へ」で利用を開始できます。汎用性と安全性を高めるため「支払い機能」も提供しています。「上級機能チュートリアル」をご参照ください。',

  text_3_4: '注意事項',
  text_3_4_1:
    '1. TokenPocket は PIN を保存しません。必ずご自身で記録・保管してください。',
  text_3_4_2:
    '2. 各カードの PIN は個別に設定できます。連続10回の誤入力でカード内のデータは完全消去されます。',
  text_3_4_3: '3. バックアップには新しい KeyPal Card の使用を推奨します。',
  text_3_4_4:
    '4. カードのリセットは全データを完全かつ不可逆に削除します。十分にご理解ください。',
  text_3_4_5:
    '5. iOS でのバックアップや使用時は反応が遅い場合があります。正常ですのでお待ちください。',

  text_4_1: 'インポート手順',
  text_4_2_1:
    'バックアップ済みの KeyPal Card から TokenPocket へウォレットを取り込めます。単一ネットワーク/複数ネットワークの両方式に対応し、ここでは単一方式に近い「複数ネットワーク方式」を中心に説明します。',
  text_4_3_1:
    '1. 「ウォレットをインポート」を選び、「KeyPal ハードウェアウォレット」をタップ。ポップアップで「KeyPal Card」を選択します。',
  text_4_3_2:
    '2. 「KeyPal Card」を選択後、「インポート開始」をタップしてカードの PIN を入力します。',
  text_4_3_3:
    '3. PIN 入力後、自動でスキャン画面に移動します。カードを背面カメラ付近にかざし、「スキャン開始」で NFC 感知と読取を開始。iOS では少し時間がかかる場合があります。',
  text_4_3_4:
    '4. 復元フレーズの読取が成功すると通知されます。「次へ」でネットワークを選択してウォレットを作成し、利用を開始します。なお「支払い機能」については「上級機能チュートリアル」を参照ください。',

  text_4_4: '注意事項',
  text_4_4_1:
    '1. iOS でのバックアップ/使用は遅く感じる場合があります。正常です。',
  text_4_4_2:
    '2. 読取前に PIN の入力が必要です。連続10回の誤入力で全データが自動消去されます。正しく入力するとカウントはリセットされます。',
  text_4_4_3:
    '3. 「支払い機能」利用時、復元フレーズは端末に保存されません。取引のたびにカードをスキャンして署名します。',

  text_5_1: '上級チュートリアル',
  text_5_2_1:
    '支払い機能により、ニーモニックや秘密鍵をオフラインのまま（端末に保存せず）安全性を高めつつ、カードの汎用性を向上します。',
  text_5_3_1:
    '1. 作成/インポート時に「詳細設定」で、復元フレーズや秘密鍵を端末に保存しない選択が可能です。以降のトランザクションはカードのスキャンで署名します。',
  text_5_3_2:
    '2. 送金や DApp 取引を開始すると、パネル下部に「カードをスキャンして支払い」と表示されます。タップして支払いフローへ進みます。',
  text_5_3_3:
    '3. 「カードをスキャンして支払い」をタップ後、本人確認のためカードの PIN を入力します。',
  text_5_3_4:
    '4. 案内に従いカードをかざして読取・署名を行います。署名完了後、取引はブロックチェーンに送信されます。',

  text_5_4: '注意事項',
  text_5_4_1:
    '1. 読取前に PIN 入力が必要です。10回連続の失敗で全データが消去され、正しい入力でカウントはリセットされます。',
  text_5_4_2:
    '2. 「支払い機能」利用時、復元フレーズは端末に保存されません。毎回カードをスキャンして署名します。',
};
